import axios from 'axios';

export default {
    get(id, slug) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/monitoring-export-retrievals/' + id, {responseType:'arraybuffer'}).then((x) => {
            var newBlob = new Blob([x.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');

            link.href = data;
            link.download = slug + '.xlsx';

            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            setTimeout(function () {
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);
        });
    },
}
